module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-help-a8cfca340b90905a3a3a44f399c4393c.svg";